import React, { useEffect, useState, useRef } from 'react';

// import './FloatingButton.css';
import { MdClose } from 'react-icons/md';
import { useLanguage } from '../contexts/LanguageContext';

// Cookie banner height on mobile (must match CookieConsent.css @media height)
const COOKIE_BANNER_HEIGHT = 92;

const FloatingButton = ({ activeDiv, setActiveDiv }) => {
  const { t, language } = useLanguage();
  useEffect(() => {
    const importCss = async () => {
      try {
        await import('./FloatingButton.css');//replacing the css with the css of the gallery of the suites
      } catch (err) {}
    };
    importCss();
  }, []);
  const [showBookingOverlay, setShowBookingOverlay] = useState(false);
  const sboxRef = useRef(null);

  // Track whether cookie consent banner is visible so we can shift the button above it
  const [cookieConsented, setCookieConsented] = useState(() =>
    document.cookie.includes('hamakomSuitesCookieConsent=true')
  );

  useEffect(() => {
    const handleConsent = () => setCookieConsented(true);
    window.addEventListener('cookieConsentAccepted', handleConsent);
    return () => window.removeEventListener('cookieConsentAccepted', handleConsent);
  }, []);

  const [showSearchBox, setShowSearchBox] = useState(false);

  return (
    <>

      <div
        className="butba23"
        style={!cookieConsented ? { bottom: `${COOKIE_BANNER_HEIGHT}px` } : {}}
      >
        <button className="floating-button" onClick={() => {setShowBookingOverlay(true);setActiveDiv('div1');}}>
          {t('floatingButton.bookVacation')}
        </button>
        
      </div>

      <div className={`booking-overlay ${showBookingOverlay ? 'show' : ''}`} id="booking-overlay" data-lenis-prevent style={{direction: language === 'he' ? 'rtl' : 'ltr'}}>
        <button className="close-button" onClick={() => {setShowBookingOverlay(false);}}><MdClose /></button>
        <h3 style={{textAlign: 'center'}}>{t('navigation.selectDates')}</h3>
        <div className='bo-wrap'>
          {activeDiv === 'div1' && <div key={language} ref={sboxRef} id="sbox" data-url={`https://bookingresults.com/2020.hamakom-suites/actionUrl?lang=${language === 'he' ? 'heb' : 'en'}`}></div>}
        </div>
        {/* Include booking form or other content here */}
      </div>
    </>
  );
};

export default FloatingButton;
